export default __webpack_public_path__ + "static/media/21-Annual-Football-Tournament.a6ccc259.jpeg";